module.exports = __webpack_public_path__ + "img/2-2.22fcff09.jpg";